import type {FC, ReactNode} from 'react';
import {cn} from '../../../../../lib/classname';

type Props = {
  /** クリック時のハンドラ */
  onClick: () => void;
  /** ボタンの無効化状態 */
  disabled?: boolean;
  /** ローディング状態 */
  isLoading?: boolean;
  /** ボタンのラベルテキスト */
  children: ReactNode;
  /** ローディング中に表示するテキスト */
  loadingText?: string;
  /** 追加のCSSクラス */
  className?: string;
};

/**
 * モーダル用の送信ボタンコンポーネント
 *
 * @description
 * モーダル内で使用する標準的な送信ボタン。
 * プライマリカラーの背景を持ち、ローディング状態に対応。
 */
export const ModalSubmitButton: FC<Props> = ({
  onClick,
  disabled = false,
  isLoading = false,
  children,
  loadingText = '保存中...',
  className,
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type="button"
      className={cn(
        'min-w-[128px] text-base font-bold rounded-full px-16 py-[10px] border-[2px] border-primary bg-primary text-white hover:opacity-80',
        isDisabled && 'opacity-80 cursor-not-allowed',
        className,
      )}
      onClick={onClick}
      disabled={isDisabled}
    >
      {isLoading ? loadingText : children}
    </button>
  );
};
